import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from '../modal.config';
import { ConfirmationModalService } from './confirmation-modal.service';

@Component({
    selector: 'app-singleton-confirmation-modal',
    templateUrl: './singleton-confirmation-modal.component.html',
    styleUrls: ['./singleton-confirmation-modal.component.scss'],
    standalone: false
})
export class SingletonConfirmationModalComponent {
  @Input() public modalConfig: ModalConfig;
  @ViewChild('modal') private modalContent: TemplateRef<SingletonConfirmationModalComponent>;
  private modalRef: NgbModalRef;

  constructor(private modalService: NgbModal, confirmationModalService: ConfirmationModalService) { 
    confirmationModalService.confirmationModalComponent = this;
  }

  open(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalRef = this.modalService.open(this.modalContent, { size: 'sm' });
      this.modalRef.result.then(resolve, resolve);
    });
  }

  openMd(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalRef = this.modalService.open(this.modalContent, { size: 'md', backdrop: 'static', keyboard: false  });
      this.modalRef.result.then(resolve, resolve);
    });
  }

  async close(): Promise<void> {
    if (
      this.modalConfig.shouldClose === undefined ||
      (await this.modalConfig.shouldClose())
    ) {
      const result =
        this.modalConfig.onClose === undefined ||
        (await this.modalConfig.onClose());
      this.modalRef?.close(result);
    }
  }

  async dismiss(): Promise<void> {
    if (this.modalConfig.disableDismissButton !== undefined) {
      return;
    }

    if (
      this.modalConfig.shouldDismiss === undefined ||
      (await this.modalConfig.shouldDismiss())
    ) {
      const result =
        this.modalConfig.onDismiss === undefined ||
        (await this.modalConfig.onDismiss());
      this.modalRef.dismiss(result);
    }
  }
}
